import Constants from '../Constants';
import * as Helpers from '../Utilities/Common';
import { normalizeData } from '../Schemas';
import { toggleModal } from './ModalActions';


const { GET_USERS, USERS_LOADING, ADD_USER, ADD_USER_FAIL, UPDATE_USER, UPDATE_USER_FAIL, DELETE_USER, RESET_USERS_ALERT, SEND_DETAILS } = Constants;

export const getUsers = (token, newQuery = {}, append = true) => async (dispatch, getState) => {
    
    let query = { page: 1, per_page:15 };

    if(newQuery !== false){
        query = append ? { ...getState().userStore.query, ...newQuery } : newQuery;
    }

    dispatch(userLoading());

    const response = await Helpers.makeRequest(token,"USERS","GET","",query);

    if(response.result){
        const normalizedData = normalizeData(response.data,"users");
        dispatch({ type: GET_USERS, payload: {data: normalizedData, query: query} });
        dispatch({ type: RESET_USERS_ALERT, payload: true });
    }
}

export const resetAlert = () => (dispatch) => {
    dispatch({ type: RESET_USERS_ALERT, payload: true });
}

export const userLoading = () => ({ type: USERS_LOADING, payload: true });


export const deleteUser = (token,id) => async (dispatch) => {
    const response = await Helpers.makeRequest(token,'USERS','DELETE','','',id);
    if(response.result){
        dispatch({ type: DELETE_USER, payload: id });
    }
}

export const addUser = (token,data) => async (dispatch) => {
    
    const { name, email, password, mail_subscription, role, company_id = false } = data;
    let formData = { name, email, password, mail_subscription, role, ...company_id && { company_id } };
    const response = await Helpers.makeRequest(token,'USERS','POST',formData);

    if(response.result){
        //dispatching action ADD_USER causes the previous users state to refresh
        dispatch({ type: ADD_USER, payload: true });
        dispatch(toggleModal("users","add"));
        //getting users again. Doing this on purpose
        dispatch(getUsers(token));
    }else{
        dispatch({ type: ADD_USER_FAIL, payload: response.data });
    }

}

export const editUser = (token, data, permissions, id) => async (dispatch) => {
    const { name, mail_subscription, role, password } = data;
    let formData = { name, mail_subscription, role };

     if(password !== "") formData.password = password;

    const response = await Helpers.makeRequest(token,'USERS','PUT',formData,'',id);
    if(response.result){
        dispatch({ type: UPDATE_USER, payload: response.data.user });
        dispatch(toggleModal("users","edit"));
    }else{
        dispatch({ type: UPDATE_USER_FAIL, payload: response.data });
    }
}

export const sendDetails = (token, email) => async (dispatch) => {

    const response = await Helpers.makeRequest('', 'REQUEST_RESET', 'PUT', { email });
    
    if(response.result){
        dispatch({ type: SEND_DETAILS, payload: email });
    }
}



// WEBPACK FOOTER //
// ./src/Actions/UserActions.js